export default "__VITE_ASSET__DGa4GJQ7__"